import React, { useState } from 'react';
import { EditableSection } from '../common/EditableSection';
import { FormTextArea } from '../common/FormTextArea';

interface ProfileSummarySectionProps {
  summary: string;
  onUpdate: (summary: string) => void;
}

export const ProfileSummarySection: React.FC<ProfileSummarySectionProps> = ({
  summary,
  onUpdate
}) => {
  const [isEditing, setIsEditing] = useState(false);
  const [editSummary, setEditSummary] = useState(summary);

  const handleEdit = () => {
    setEditSummary(summary);
    setIsEditing(true);
  };

  const handleCancel = () => {
    setEditSummary(summary);
    setIsEditing(false);
  };

  const handleSave = () => {
    onUpdate(editSummary);
    setIsEditing(false);
  };

  return (
    <EditableSection
      title="Profile Summary"
      isEditing={isEditing}
      onEdit={handleEdit}
      onSave={handleSave}
      onCancel={handleCancel}
    >
      {isEditing ? (
        <FormTextArea
          label=""
          name="profile_summary"
          value={editSummary}
          onChange={(e) => setEditSummary(e.target.value)}
          placeholder="Write a brief summary about yourself..."
          maxLength={3000}
          rows={8}
        />
      ) : (
        <div className="prose prose-sm max-w-none">
          {summary ? (
            <p className="text-gray-700 whitespace-pre-wrap">{summary}</p>
          ) : (
            <p className="text-gray-500 italic">No profile summary added yet.</p>
          )}
        </div>
      )}
    </EditableSection>
  );
};